<template>
  <div>
    <div class="passoEditarRegistro">
      <div class="passoEditarRegistro_header"
           :class="{'passoEditarRegistro_header_error': propCorrecoes['DATA DO REGISTRO']}">
        <h3 class="passoEditarRegistro_header_title">
          Registrador
          <span v-if="propCorrecoes['DATA DO REGISTRO']">
            <IconSvg class="icon-error-campo"
                     icon="alert" />
            Há campos incorretos
          </span>
        </h3>
      </div>
      <div class="px-2 pt-2 mb-4">
        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label
                class="label"
                for="digitador">Digitador</label>
              <select id="digitador"
                      v-model="localData.digitador"
                      class="custom-select custom-select-sm"
                      name="digitador"
                      :disabled="!digitadores.length"
                      @change="updated">
                <option v-if="!digitadores.length"
                        value="">
                  Não existem digitadores
                </option>
                <option v-for="(usuario, index) in digitadores"
                        :key="index"
                        :value="usuario.nome">
                  {{ usuario.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label
                class="label"
                for="escrevente">Escrevente</label>
              <select id="escrevente"
                      v-model="localData.escrevente"
                      class="custom-select custom-select-sm"
                      name="escrevente"
                      :disabled="!escreventes.length"
                      @change="changeEscrevente()">
                <option v-if="!escreventes.length"
                        value="">
                  Não existem escreventes
                </option>
                <option v-for="(escrevente, index) in escreventes"
                        :key="index"
                        :value="escrevente.nome">
                  {{ escrevente.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label class="label"
                     :class="{'label-error': propCorrecoes['DATA DO REGISTRO']}"
                     for="data_registro">Data do registro
                <span v-if="propCorrecoes['DATA DO REGISTRO']">
                  <IconSvg class="icon-error-campo"
                           icon="alert" />
                </span>
              </label>
              <input id="data_registro"
                     v-model="localData.data_registro"
                     v-validate="`date_format:yyyy-MM-dd|date_between:${ dataInicial() },${ dataLimite() }, (include)`"
                     name="data_registro"
                     required
                     :class="{ 'is-invalid': errors.has('data_registro') || propCorrecoes['DATA DO REGISTRO'] }"
                     class="form-control form-control-sm"
                     type="date"
                     @change="validateInputs('data_registro')">
              <small v-if="errors.has('data_registro')"
                     class="invalid-feedback">{{ errors.first('data_registro') }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="passoEditarRegistro_header">
        <h3 class="passoEditarRegistro_header_title">
          Registro
        </h3>
      </div>

      <div class="row px-2 pt-2 mb-4">
        <div class="col-2">
          <label class="label"
                 for="AcervoRegistro">Acervo</label>
          <select id="AcervoRegistro"
                  v-model="localData.acervo"
                  v-validate="'required'"
                  :class="{'is-invalid' : errors.has('registro_acervo')}"
                  class="form-control form-control-sm"
                  name="registro_acervo"
                  placeholder="00"
                  @change="updated()">
            <option :value="1">
              01
            </option>
            <option :value="2">
              02
            </option>
          </select>
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Livro</label>
          <input v-model="localData.numLivro"
                 v-validate="'required'"
                 type="number"
                 name="registro_livro"
                 :class="{'is-invalid' : errors.has('registro_livro')}"
                 class="form-control form-control-sm"
                 @change="updated()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Folha</label>
          <input v-model="localData.folha"
                 v-validate="'required'"
                 type="number"
                 name="registro_folha"
                 :class="{'is-invalid' : errors.has('registro_folha')}"
                 class="form-control form-control-sm"
                 @change="updated()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Termo</label>
          <input v-model="localData.termo"
                 v-validate="'required'"
                 type="number"
                 name="registro_termo"
                 :class="{'is-invalid' : errors.has('registro_termo')}"
                 class="form-control form-control-sm"
                 @change="updated()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Lado</label>
          <select v-model="localData.lado"
                  v-validate="'required'"
                  name="registro_lado"
                  :class="{'is-invalid' : errors.has('registro_lado')}"
                  class="form-control form-control-sm"
                  @change="updated()">
            <option>FRENTE</option>
            <option>VERSO</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UsuarioService from "@/services/Auth/UsuarioService"
  import moment  from "moment"

  export default {
    name: 'PassoEditarRegistro',
    inject: ['$validator'],
    props: {
      data: {type: Object, default: () => ({})},
      propCorrecoes: {type: Object, default: () => ({})}
    },
    data () {
      return {
        localData: {
          digitador: '',
          escrevente: '',
          origem: this.data.origem,
          data_registro: new Date().toISOString().split('T')[0],
          termo: '',
          numLivro: '',
          folha: '',
          lado: '',
          cargo_escrevente: '',
          acervo: ''
        },
        sequenciaRegistro: null,
        limitdate: new Date().toISOString().split('T')[0],
        escreventes: [],
        digitadores: [],
        oficiais: []
      }
    },
    watch: {
      data (newObj, oldObj) {
        if (Object.entries(newObj).length) this.setData(newObj)
      }
    },

    async created () {
      this.localData = {
        digitador: this.user && this.user.nome || '',
        escrevente: this.escrevente || '',
        data_registro: new Date().toISOString().split('T')[0],
        ...this.data.registro,
      }
      this.localData.origem = "novo"
      await this.loadUsers()
      document.querySelector('#digitador').focus()
    },
    methods: {
      async loadUsers () {
        const response = await UsuarioService.getUsuarios()
        if (!response || !response.data) return

        this.escreventes = []
        this.digitadores = []
        this.oficiais = []

        let usuarios = response.data || []

        this.digitadores = usuarios
        this.escreventes = usuarios.filter(usuario => usuario.escrevente === 1 )
        this.oficiais = usuarios
      },
      dataLimite () {
        return moment(this.limitdate).format("YYYY-MM-DD")
      },
      dataInicial () {
        return moment('1500/01/01').format("YYYY-MM-DD")
      },

      setData (val) {
        if (!this.sequenciaRegistro) {
          // pegando sequencia de dado do registro para identificar mudanca
          let { registro: { livro: { num_livro, acervo }, folha, termo } } = val
          this.sequenciaRegistro = [num_livro, acervo, folha, termo].join('')
        }

        this.localData.data_registro = val.registro.data_registro
        this.localData.digitador = val.registro.digitador
        this.localData.escrevente = val.registro.escrevente
        this.localData.cargo_escrevente = val.registro.cargo_escrevente

        Object.assign(this.localData, {
          numLivro: this.data.registro && this.data.registro.livro.num_livro,
          folha: this.data.registro && this.data.registro.folha,
          termo: this.data.registro && this.data.registro.termo,
          lado: this.data.registro && this.data.registro.lado,
          acervo: this.data.registro && !!this.data.registro.acervo ? this.data.registro.acervo : this.data.registro.livro.acervo
        })

      },
      changeOrigin () {
        this.localData.origem = 'legado'
      },
      changeEscrevente () {
        if (this.localData.escrevente) {
          const selectEscreventes = document.getElementById('escrevente')
          this.localData.cargo_escrevente  = this.escreventes[selectEscreventes.selectedIndex].cargo
        }
        this.updated()

      },
      updated () {
        let obj = { ...this.data }
        
        const sequenciaLocal = [this.localData.numLivro, this.localData.acervo, this.localData.folha, this.localData.termo].join('')

        if ((this.sequenciaRegistro != sequenciaLocal) || (this.localData.data_registro != this.data.registro.data_registro)) {
          this.localData.origem = 'legado'
        } else {
          this.localData.origem = 'novo'
        }

        obj.registro.data_registro = this.localData.data_registro
        obj.registro.digitador = this.localData.digitador
        obj.registro.escrevente = this.localData.escrevente
        obj.registro.cargo_escrevente = this.localData.cargo_escrevente

        obj.registro.livro.num_livro = this.localData.numLivro
        obj.registro.folha = this.localData.folha
        obj.registro.termo = this.localData.termo
        obj.registro.lado = this.localData.lado
        obj.registro.origem = this.localData.origem,
        obj.registro.acervo = this.localData.acervo

        this.$validator.validateAll().then((resp) => {
          if (resp) this.$emit('changed', obj)
        })
      },

      validateInputs (name) {
        if (name == "data_registro") this.deleteError(['DATA DO REGISTRO'])

        this.$validator.validate(name)
        this.updated()
      },
      deleteError (error) {
        this.$emit('deleteError', error)
      }

    }
  }
</script>

<style lang="scss">
  @import '../../../../scss/_utilities/exports';

  .passoEditarRegistro {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_error {
        color: #8B0000
      }

      &_title {
        @extend %titleBox_title;
      }
    }
  }
</style>
